import { Grid } from '@mui/material';
import React from 'react';
import { FullScreenHandle } from 'react-full-screen';
import { ChartTitle } from '../chart-title/ChartTitle';
import { ChartDisplayConfig } from '../common-chart-types';
import { CHART_TITLE_HEIGHT } from '../common-chart-utils/common-chart-styles';
import { ChartTools } from '../tools/ChartTools';

interface ChartTitleConfig {
  mainTitle: string;
  extraContent?: React.ReactNode;
}

interface ChartHeaderProps {
  titleConfig: ChartTitleConfig;
  showTools: boolean;
  chartRef: React.RefObject<HTMLElement>;
  fullScreenHandle: FullScreenHandle;
  displayConfig: ChartDisplayConfig;
}

export const ChartHeader = ({
  titleConfig,
  showTools,
  chartRef,
  fullScreenHandle,
  displayConfig,
}: ChartHeaderProps) => (
  <Grid
    item
    container
    sx={{
      height: CHART_TITLE_HEIGHT,
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Grid item sx={{ flexShrink: 1, minWidth: 0 }}>
      <ChartTitle
        title={titleConfig.mainTitle}
        extraContent={titleConfig.extraContent}
      />
    </Grid>
    {showTools ? (
      <Grid item sx={{ flexShrink: 0 }}>
        <ChartTools
          chartRef={chartRef}
          fullScreenHandle={fullScreenHandle}
          displayConfig={displayConfig}
        />
      </Grid>
    ) : null}
  </Grid>
);
